var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:( _obj = {}, _obj['size-'+_vm.size] = _vm.size, _obj ),style:(_vm.contents)},[_vm._t("tooltip-content"),_c('div',{staticClass:"flex-content text-center"},[_c('div',{staticClass:"avatar-inner"},[_vm._t("default")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }